export const ARTICLES_PER_PAGE = 9;

export const CATEGORIES = [null, 'lectures', 'diet', 'tips', 'motivation'];
